var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F7F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 34H31.5V38H29.5V34ZM34.5 32H36.5V38H34.5V32ZM24.5 28H26.5V38H24.5V28Z",
    fill: "#0516C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 19H36.5V18C36.5 17.4696 36.2893 16.9609 35.9142 16.5858C35.5391 16.2107 35.0304 16 34.5 16H26.5C25.9696 16 25.4609 16.2107 25.0858 16.5858C24.7107 16.9609 24.5 17.4696 24.5 18V19H21.5C20.9696 19 20.4609 19.2107 20.0858 19.5858C19.7107 19.9609 19.5 20.4696 19.5 21V42C19.5 42.5304 19.7107 43.0391 20.0858 43.4142C20.4609 43.7893 20.9696 44 21.5 44H39.5C40.0304 44 40.5391 43.7893 40.9142 43.4142C41.2893 43.0391 41.5 42.5304 41.5 42V21C41.5 20.4696 41.2893 19.9609 40.9142 19.5858C40.5391 19.2107 40.0304 19 39.5 19ZM26.5 18H34.5V22H26.5V18ZM39.5 42H21.5V21H24.5V24H36.5V21H39.5V42Z",
    fill: "#0516C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.d4a3bc5ec06b8f656980e3ac22a482cb.svg";
export { ForwardRef as ReactComponent };